import React, { useCallback, useEffect, useState } from 'react'
import ServicesTable from './ServicesTable/ServicesTable';
import Loader from '../../Loader/Loader';
import { getServicesAPI } from '../../utils/APIs/servicesApis';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = sessionStorage.getItem("isSidebarOpen");
    return stored !== null ? JSON.parse(stored) : true;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed = stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [isSidebarOpen]);


  const mapPaymentsResponse = (services = []) =>
    services.map((item) => ({
      id: item?._id,
      serviceName: item?.serviceName,
      isAdditionalServices: item?.isAdditionalServices

    }));

  const fetchPayments = useCallback(async () => {
    setLoading(true);

    try {
      const res = await getServicesAPI();
      console.log("RESPONSE", res?.data?.data)
      setServices(mapPaymentsResponse(res?.data?.data));
      // setTotal(res?.data?.meta?.total);
    } catch (err) {
      console.error("Payments fetch failed", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);




  if (loading) {
    return <Loader />
  }

  return (
    <div
      className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      style={{ marginTop: "100px" }}
    >
      <div className="page-inner-wrapper">
        <h2 className="page-title">Services</h2>

        <ServicesTable data={services} />



      </div>
    </div>
  )
}

export default Services